import { useNavigate } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Box, IconButton, Tooltip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './maintenanceGrid.scss';

interface MaintenanceOption {
  id: string;
  title: string;
  description: string;
  icon: React.ReactElement;
  path: string;
}

interface MaintenanceGridProps {
  options: MaintenanceOption[];
}

const MaintenanceGrid: React.FC<MaintenanceGridProps> = ({ options }) => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(`/mantenimiento/${path}`);
  };

  return (
    <Grid container spacing={3} className="maintenance-grid">
      {options.map((option) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={option.id}>
          <Card 
            className="maintenance-card"
            onClick={() => handleNavigate(option.path)}
          >
            <CardContent className="card-content">
              <Box className="icon-container">
                {option.icon}
              </Box>
              
              <Box className="text-content">
                <Typography variant="h6" className="card-title">
                  {option.title}
                </Typography>
                <Typography variant="body2" className="card-description">
                  {option.description}
                </Typography>
              </Box>

              <Box className="card-footer">
                <Tooltip title="Acceder al módulo">
                  <IconButton 
                    size="small" 
                    className="action-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNavigate(option.path);
                    }}
                  >
                    <ArrowForwardIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default MaintenanceGrid;